import {HttpContextToken, HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {LoadingService} from '../loading/loading.service';

export const IGNORE_LOADING = new HttpContextToken<boolean>(() => false);

export function loadingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const loadingService = inject(LoadingService);
  const router = inject(Router);

  // Get current route
  const currentRoute = router.url;

  // Only show loading for /ui/secure paths
  if (!isSecurePath(currentRoute)) {
    return next(req);
  }

  loadingService.show();

  return next(req)
    .pipe(
      finalize(() => {
        loadingService.hide();
      })
    );
}

function isSecurePath(url: string): boolean {
  // Check if the current route is a secure path
  // This includes /ui/secure and /secure/admin paths
  return url.includes('/secure') || url.includes('/ui/secure');
}
